<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="primary">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand href="https://www.uniauc.com">
        <div class="logo-container">
          <!--          <div class="logo">-->
          <img src="@/assets/img/img_logo.png" alt="유니옥션 로고" />
          <!--          </div>-->
          <div class="brand">
            <!--            유니옥션-->
          </div>
        </div>
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <!--<b-nav-item href="#">Link</b-nav-item>-->
          <!--<b-nav-item href="#" disabled>Disabled</b-nav-item>-->
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto"></b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- navbar-1.vue -->
    <b-container fluid>
      <h3 class="mt-5">
        {{ $t("배송요금안내") }}
      </h3>
      <b-nav pills justified class="my-3">
        <b-nav-item
          :active="region == 'US'"
          @click="$router.push({ params: { region: 'US', method: 'air' } })"
          >미국
        </b-nav-item>
        <b-nav-item
          :active="region == 'CN'"
          @click="$router.push({ params: { region: 'CN', method: 'marine' } })"
        >
          중국
        </b-nav-item>
        <b-nav-item
          :active="region == 'DE'"
          @click="$router.push({ params: { region: 'DE', method: 'air' } })"
        >
          독일
        </b-nav-item>
        <b-nav-item
          :active="region == 'JP'"
          @click="$router.push({ params: { region: 'JP', method: 'air' } })"
        >
          일본
        </b-nav-item>
      </b-nav>
      <b-nav
        v-if="['US', 'JP', 'DE'].includes(region)"
        tabs
        justified
        class="my-3"
      >
        <b-nav-item :active="method == 'air'" @click="changeMethod('air')">
          일반배송
        </b-nav-item>
      </b-nav>
      <b-nav v-if="region == 'CN'" tabs justified class="my-3">
        <b-nav-item
          :active="method == 'marine'"
          @click="changeMethod('marine')"
        >
          해상운송
        </b-nav-item>
        <b-nav-item :active="method == 'air'" @click="changeMethod('air')">
          항공운송
        </b-nav-item>
        <!--        <b-nav-item :active="method == 'ems'" @click="changeMethod('ems')"-->
        <!--          >국제특급우편(EMS)</b-nav-item-->
        <!--        >-->
      </b-nav>
      <h5>기본 운송비</h5>
      <b-table
        :per-page="10"
        :current-page="currentPage"
        small
        striped
        responsive
        :items="items"
        :fields="fields"
        head-variant="light"
      >
      </b-table>
      <b-pagination
        v-if="items"
        :per-page="10"
        :limit="8"
        v-model="currentPage"
        :total-rows="items.length"
        align="center"
      ></b-pagination>
      <b-card class="bg-light">
        <b-card-body>
          실적 할인은 미국 센터에만 적용되며, 이용건수 충족시 자동반영
          됩니다.<br />
          쿠폰 할인과 중복할인 되며 퍼센트 할인은 최고 15%까지 가능합니다.<br />
          2022.1.1 항공사/선사 요율 인상으로 중국/독일/일본 요율이 소폭
          변경되었으니 변경된 요율을 확인 부탁드립니다.
        </b-card-body>
      </b-card>
      <h5 class="mt-5">부피무게 관련 주의사항</h5>
      <b-card class="bg-light">
        <b-card-body>
          <div v-if="region == 'US'">
            <p>
              * 미국센터의 경우 실무게에 비해 부피무게가 큰 경우 부피무게가
              적용됩니다.
            </p>
            ① 부피무게는 '가로(inch) x 세로(inch) x 높이(inch) ÷ 166' 으로
            계산하며, 수입신고시에는 부피무게가 아닌 실무게로 신고됩니다.<br />
            ② 부피무게 적용시 16 파운드 미만의 경우는 부피무게가 20% 할인되며,
            9파운드 미만의 경우 실무게와 부피무게 차이가 5파운드 이내인 경우
            실무게로만 책정됩니다. 16파운드 이상의 경우 부피무게 50%할인한
            금액과 실무게에 10파운드를 더한 금액중 큰 쪽으로 적용됩니다.
            <br />단, 한 변의 길이가 40인치 이상이거나 사업자 건 및 대량발송의
            경우는 그대로 100% 부피무게가 적용됩니다.<br />
            ③ 가로, 세로, 높이 중 한 변이 70인치를 초과하는 경우, 항공발송이
            불가할 수 있으므로 구매전 별도 문의바랍니다.<br />

            <!--          ④ -->
            <br />
          </div>
          <div v-if="region == 'JP'">
            <p>
              * 일본센터의 경우 실무게에 비해 부피무게가 큰 경우 부피무게가
              적용됩니다.
            </p>
            ① 부피무게는 '가로(cm) x 세로(cm) x 높이(cm) ÷ 6000' 으로
            계산합니다.<br />
            ② 가로, 세로, 높이 중 한 변이 70인치를 초과하는 경우, 발송이 불가할
            수 있으므로 구매전 별도 문의바랍니다.<br />

            <!--          ④ -->
            <br />
          </div>
          <div v-else-if="region == 'CN'">
            중국센터의 해상운송비용은 현재 부피무게가 부과되지 않으며
            실무게만으로 청구됩니다.<br />
            하지만 중대형 화물의 경우 국내택배비용 상승으로 인해 약간의
            추가비용이 발생할 수 있습니다. (기타 추가청구비용 안내 참조)
          </div>
        </b-card-body>
      </b-card>

      <h5 class="mt-5">기타 추가청구비용</h5>
      <table class="table">
        <thead>
          <tr>
            <th>항목</th>
            <th>요금</th>
            <th>내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>화물택배</td>
            <td>실비청구</td>
            <td>
              일반택배사에서 핸들링이 불가능한 사이즈 또는 액체류의 경우
              화물택배로 발송되며, 착불형태로 청구됩니다.<br />
              기본요금에 포함되어 있는 택배비용은 화물택배비로 전달하는 과정에서
              발생하는 인건비로 충당되기 때문에 환불되지 않습니다.
            </td>
          </tr>
          <tr>
            <td>기본검수</td>
            <td>신청서당 $0.5</td>
            <td>
              신청서에 기재된 수량, 색상, 사이즈, 상품명, 이미지URL과 실제
              도착한 상품들을 대조해 드립니다.
            </td>
          </tr>
          <tr>
            <td>위험물(독일)</td>
            <td>신청서당 $5</td>
            <td>
              독일건만 해당하며, 배터리, 전자제품, 향수, 가연성 제품 등은
              위험물취급수수료 $5가 추가될 수 있습니다.
            </td>
          </tr>
          <tr>
            <td>정밀검수</td>
            <td>아이템당 $1</td>
            <td>
              기본검수를 신청하는 경우에만 신청이 가능하며 상품에 일반적인
              하자가 없는지 정밀히 검수해 드립니다.
            </td>
          </tr>
          <tr>
            <td>사진촬영</td>
            <td>아이템당 $0.5</td>
            <td>
              사진을 어떻게 찍어야 하는지에 대해서는 고객님들의 요구가 각각
              다르기에 마음에 안 드실 경우 재촬영은 무료로 해드리고 있습니다.
            </td>
          </tr>
          <tr>
            <td>파손보험</td>
            <td>상품가의 5%</td>
            <td>
              상품가 $500까지는 보험이 무료로 포함됩니다. $500 이상의 경우
              별도로 말씀해 주셔야 보험적용을 해드리고 있으며 말씀하시지 않은
              경우 분실 및 파손의 최대 보상 한도는 $500까지입니다.
            </td>
          </tr>
          <tr>
            <td>묶음배송</td>
            <td>박스당 $1</td>
            <td>오더번호 3건까지는 무료로 묶음배송 해드립니다.</td>
          </tr>
          <tr>
            <td>재포장</td>
            <td>박스당 $3</td>
            <td>
              배송비가 이미 책정된 건에 대해 묶음, 분리 등을 요청하실 경우
              청구됩니다.
            </td>
          </tr>
          <tr>
            <td>장기보관</td>
            <td>박스당 기본 $10 + 매일 $1</td>
            <td>
              상품도착 후 30일 경과시 기본$10 청구되며 매일마다 $1씩 청구됩니다.
            </td>
          </tr>
          <tr>
            <td>멀티박스</td>
            <td>박스당 $3</td>
            <td>
              묶음배송이 불가능하거나 묶음배송을 하면 위험한 상품의 경우
              묶음포장 없이 여러 건의 박스로 나가게 됩니다.<br />
              이때 국내에서는 개별 택배로 취급되게 되는데, 박스당 $3이
              추가됩니다.
            </td>
          </tr>
          <tr>
            <td>분할배송</td>
            <td>박스당 $3</td>
            <td>
              관세회피 목적의 분할배송은 불가능하며, 실수령인이 다를 경우만
              분할이 가능합니다.
            </td>
          </tr>
          <tr v-if="region == 'US'">
            <td>델라웨어 운반</td>
            <td>신청서당 $1</td>
            <td>
              델라웨어로 신청하신 경우 묶음배송과 상관없이 신청서당 청구됩니다.
              뉴저지 도착건과 묶음배송이 가능합니다.
            </td>
          </tr>
          <tr v-if="region == 'US'">
            <td>선출고건 결제지연</td>
            <td>매일 $5</td>
            <td>
              선출고 배송건이 출고된 후 48시간 이내에 결제되지 않을 경우
              지연수수료가 매일 $5씩 청구됩니다.
            </td>
          </tr>
        </tbody>
      </table>
      <h5 class="mt-5">사업자요금 안내</h5>
      <b-card>
        <b-card-body>
          사업자요금은 물량과 중량, 검수, 보험 등 부가서비스에 따라
          개별책정됩니다. 1:1 문의게시판으로 문의 부탁드립니다.
        </b-card-body>
      </b-card>
      <h5 class="mt-5">결제 안내</h5>
      <b-card>
        <b-card-body>
          * 모든 요금은 US 달러 기준이며 해외 결제가 가능한 신용카드 또는
          체크카드로만 결제가 가능합니다.
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>
<script>
const shippingMethods = {
  US: ["air"],
  CN: ["marine", "air", "ems"],
  JP: ["air"],
  DE: ["air"],
};

const feesFormula = {
  US: {
    air: {
      label: "항공",
      starting: 11.5,
      adding: 2,
    },
  },
  JP: {
    air: {
      label: "항공",
      starting: 13.5,

      adding: 2.9,
    },
  },
  DE: {
    air: {
      label: "항공",
      starting: 13,
      adding: 2.5,
    },
  },
  CN: {
    air: {
      label: "항공",
      starting: 11.5,
      adding: 3.2,
    },
    marine: {
      label: "해상",
      starting: 11.5,
      adding: 2.2,
    },
    ems: {
      label: "EMS",
      starting: 20,
      adding: 4,
    },
  },
};
const primeFeesFormula = {
  US: {
    air: {
      starting: 10,
      adding: 1.8,
    },
  },
  CN: {
    ems: {
      starting: 20,
      adding: 4,
    },
    air: {
      starting: 9,
      adding: 2.7,
    },
    marine: {
      starting: 9,
      adding: 1.7,
    },
  },
};

function getPrimeFees(region, method, weight) {
  if (!weight) return false;
  let fee = 0;
  const { starting, adding } = primeFeesFormula[region][method];
  fee =
    region == "US"
      ? starting + Math.ceil(weight - 1) * adding
      : (Math.ceil(weight * 2) - 1) * adding + starting;

  return fee;
}

function getFees(region, method, weight, level = 0) {
  if (level === "prime") return getPrimeFees(region, method, weight);
  if (!weight) return false;
  let fee = 0;
  if (region == "US" && method == "air" && weight <= 7) {
    switch (Math.ceil(weight)) {
      case 0:
        fee = 0;
        break;
      case 1:
        fee = 10.5;
        break;
      case 2:
        fee = 12;
        break;
      case 3:
        fee = 14.5;
        break;
      case 4:
        fee = 17;
        break;
      case 5:
        fee = 18.5;
        break;
      case 6:
        fee = 21;
        break;
      case 7:
        fee = 23.5;
        break;
    }
  } else {
    // console.log(region, method);
    const { starting, adding } = feesFormula[region][method];
    fee =
      region == "US"
        ? starting + Math.ceil(weight - 1) * adding
        : (Math.ceil(weight * 2) - 1) * adding + starting;
  }

  return region === "DE" ? fee : fee * ((100 - level) / 100);
}

let feesByRegion = {};
for (const region of Object.keys(shippingMethods)) {
  let feesByMethod = {};
  for (const method of shippingMethods[region]) {
    let feesByWeight = [
      {
        weight: "이용건수",
        0: 0,
        1: 2,
        2: 3,
        3: 6,
        4: 11,
        5: 16,
        6: 21,
        7: 31,
        8: 46,
        9: 71,
        10: 101,
        _rowVariant: "info",
      },
    ];
    if (["US", "CN"].includes(region)) feesByWeight["prime"] = "프라임";
    for (let weightIndex = 1; weightIndex <= 150; weightIndex++) {
      let feesByLevel = {};
      const weight = region == "US" ? weightIndex : weightIndex * 0.5;
      const unit = region == "US" ? "LB" : "KG";
      for (let level = 0; level <= 10; level++) {
        feesByLevel[level] = getFees(region, method, weight, level).toFixed(2);
      }
      // feesBylevel = Array.from({ length: 10 }, (v, i) => i).reduce(
      //   (acc, level) => {
      //     acc[level] = getFees(region, method, weight, level).toFixed(2);
      //     return acc;
      //   },
      //   {}
      // );
      if (["US", "CN"].includes(region))
        feesByLevel["prime"] = getFees(region, method, weight, "prime").toFixed(
          2
        );
      feesByWeight.push({ ...feesByLevel, weight: weight + "" + unit });
    }
    feesByMethod[method] = feesByWeight;
  }
  feesByRegion[region] = feesByMethod;
}

console.log(feesByRegion);

export default {
  name: "fees",
  metaInfo: {
    title: "배송요금 안내",
  },
  components: {},
  data() {
    return {
      feesByRegion,
      currentPage: 1,
      fields: [
        {
          class: "text-center",
          thStyle: "white-space: nowrap;",
          key: "weight",
          label: "등급",
          isRowHeader: true,
        },
        {
          class: "text-center",
          key: "0",
          label: "LV0",
        },
        {
          class: "text-center",
          key: "1",
          label: "LV1",
        },
        {
          class: "text-center",
          key: "2",
          label: "LV2",
        },
        {
          class: "text-center",
          key: "3",
          label: "LV3",
        },
        {
          class: "text-center",
          key: "4",
          label: "LV4",
        },
        {
          class: "text-center",
          key: "5",
          label: "LV5",
        },
        {
          class: "text-center",
          key: "6",
          label: "LV6",
        },
        {
          class: "text-center",
          key: "7",
          label: "LV7",
        },
        {
          class: "text-center",
          key: "8",
          label: "LV8",
        },
        {
          class: "text-center",
          key: "9",
          label: "LV9",
        },
        {
          class: "text-center",
          key: "10",
          label: "LV10",
        },
        {
          class: "text-center",
          key: "prime",
          label: "프라임",
        },
      ],
    };
  },
  computed: {
    region() {
      return this.$route.params.region || "US";
    },
    method() {
      return this.$route.params.method || "air";
    },
    items() {
      return feesByRegion[this.region][this.method];
    },
  },
  methods: {
    changeMethod(method) {
      this.$router.push({ params: { method } });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
.logo-container .logo {
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #333333;
  width: 50px;
  float: left;
}

.logo-container .brand {
  font-size: 18px;
  color: #ffffff;
  line-height: 20px;
  float: left;
  margin-left: 10px;
  margin-top: 5px;
  width: 100px;
}

.logo-container .logo img {
  width: 100%;
}
</style>
